<template>
    <div>
        <slot></slot>
        <b-modal :visible="show"
            :ok-title="okTitle"
            :cancel-title="cancelTitle"
            no-close-on-backdrop
            @ok="handleOk"
            @cancel="$emit('cancel')"
            ref="modal"
            data-legacy
        >
            <slot name="title">
                <div slot="modal-title" v-html="title"></div>
            </slot>
            <slot name="text">
                <div v-html="text"></div>
            </slot>
            <template slot="modal-footer">
                <slot name="modal-footer" :handle-ok="handleOk" :handle-cancel="handleCancel"></slot>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { BModal } from 'bootstrap-vue';

    export default {
        components: {
            BModal,
        },
        props: {
            text: {
                type: String,
                default: 'Êtes-vous sûr de vouloir effectuer cette action ?'
            },
            title: {
                type: String,
                default: 'Confirmation'
            },
            okTitle: {
                type: String,
                default: 'Oui'
            },
            cancelTitle: {
                type: String,
                default: 'Non'
            },
            trigger: {
                type: Boolean,
                default: true
            },
            show: Boolean
        },

        data() {
            return {
                isOk : false,
            }
        },
        computed: {
            element() {
                return this.$slots.default[0];
            },
            listenerMap() {
                return {
                    form: 'submit',
                    a: 'click'
                }
            }
        },

        methods: {
            onElementEvent(e) {
                if(!this.isOk) {
                    e.preventDefault();
                    this.$refs.modal.show();
                }
            },
            handleOk() {
                this.$emit('ok', this.element.elm);
                this.isOk = true;
                let { elm, tag } = this.element;
                if(tag in this.listenerMap && this.trigger) {
                    elm[this.listenerMap[tag]]();
                }
                this.isOk = false;
            },
            handleCancel() {
                this.$refs.modal.hide();
            }
        },

        mounted() {
            let { elm, tag } = this.element;

            if(tag in this.listenerMap) {
                elm.addEventListener(this.listenerMap[tag], this.onElementEvent);
            }
            else {
                console.error("Can't prevent event for element : ", elm);
            }
        }
    }
</script>
